import { getColumnInfoByIndentifier } from 'models/tableColumns/selector';
import { useSelector } from 'react-redux';

export const useColumnAliasName = (tableId: string) => {
  const state = useSelector(state => state)

  const getColumnAliasName = (columnName: string): string => {
    const columnInfo = getColumnInfoByIndentifier(
      state,
      tableId,
      columnName
    );
    return columnInfo?.AppColumnAliasName || columnName;
  };

  return getColumnAliasName;
};
